import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-c46de5f2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "edit-page-ai-assistance"
};
const _hoisted_2 = {
  class: "ai-assistance-top"
};
const _hoisted_3 = {
  class: "ai-assistance-top-title"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ai-assistance-top-title-text"
}, "AI Assistance", -1));
const _hoisted_5 = {
  class: "ai-assistance-content"
};
const _hoisted_6 = {
  class: "ai-assistance-content-cards"
};
const _hoisted_7 = {
  class: "ai-assistance-buttons"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_ai_assistance_card = _resolveComponent("ai-assistance-card");
  const _component_app_button = _resolveComponent("app-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_app_icon, {
    icon: "ai",
    color: "#4D4D4D"
  }), _hoisted_4]), _createElementVNode("div", {
    class: "ai-assistance-top-close",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.onClose && $options.onClose(...args))
  }, [_createVNode(_component_app_icon, {
    icon: "cross",
    size: "20",
    color: "#616161"
  })])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_ai_assistance_card, {
    icon: "tiny-omny-icon",
    title: "Use customer insights and raw product data",
    description: "This model of Omny AI uses customer reviews on top on your product data to generate the highly converting product listings",
    selected: $data.selected_card == 'ai_generation' ? true : false,
    onClick: _cache[1] || (_cache[1] = _withModifiers($event => $options.onCardClick('ai_generation'), ["stop"]))
  }, null, 8, ["selected"]), _createVNode(_component_ai_assistance_card, {
    icon: "translate-icon",
    title: "Based on a translation from another existing Amazon listing",
    description: "Use a translated version from another existing Amazon listing to generate a prioritized list of benefits and use cases.",
    selected: $data.selected_card == 'translate' ? true : false,
    onClick: _cache[2] || (_cache[2] = _withModifiers($event => $options.onCardClick('translate'), ["stop"]))
  }, null, 8, ["selected"])])]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_app_button, {
    variant: "outline-primary",
    v2: "",
    disabled: "true"
  }, {
    default: _withCtx(() => [_createTextVNode(" Previous")]),
    _: 1
  }), _createVNode(_component_app_button, {
    variant: "outline-primary",
    v2: "",
    onClick: _cache[3] || (_cache[3] = $event => $options.onNextClick())
  }, {
    default: _withCtx(() => [_createTextVNode(" Next ")]),
    _: 1
  })])]);
}